export const displayTypes = {
  NORMAL: 1,
  REVERSE: 2,
}
